import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// global component
import Pagnation from '@/components/pagnation.vue'
Vue.component('Pagnation', Pagnation)

// element ui
import ElementUI, { Notification } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// axios
import { post } from './common/request'
import './common/request'
Vue.prototype.$post = post;

// msg
Vue.prototype.$msg = function (title = '', type) {
  Notification({
    title,
    type: type == 'e' ? 'error' : 'success'
  })
}

import { IS_OPEN_MARKET_PROCE } from '@/const/switchs'
// 全局混入
Vue.mixin({
  data() { return { IS_OPEN_MARKET_PROCE } },
  filters: {
    getTimeByFomat(duration = 0) {
      var m = parseInt(duration / 60)
      var s = duration % 60;
      m = m < 10 ? `0${m}` : m;
      s = s < 10 ? `0${s}` : s;
      return `${m}:${s}`;
    }
  },
  computed: {
    isLogin() { return !!this.$store.state.token },
    userInfo() { return this.$store.state.userInfo || {} }
  },
  methods: {
    /** 报告错题
     * @params {Object} {topic_id:currentTopic.id} 题目id
    */
    async escalationErrorTopic({ topic_id = '' }) {
      try {
        const res = await this.$post('648fb2d982145', { topic_id })
        this.$msg(res.msg || '错题上报成功')
      } catch (error) { this.$msg((error || {}).msg || '错题上报失败', 'e'); }
    },
    /**
     * 获取课程商品价格
     * @param {*} info 商品信息
     * @returns {type: 1 团购  2 售价  3  划线价  , price: 价格}
     */
    getClassPrice(info = {}) {
      /*
        rush_purchase   团购到期时间
        group_price     团购价
        sale_price      售价
        market_price    划线价【废弃】

        注：目前价格只会走到售价，0 免费
      */
      if (!+info.sale_price) return { type: 2, price: 0, }

      var result = {
        type: '',
        price: '',
      };
      if (info.rush_purchase && new Date(info.rush_purchase).getTime() > new Date().getTime()) {
        result.type = 1;
        result.price = +info.group_price;
      } else {
        result.type = 2;
        result.price = +info.sale_price || 0;
      }
      return result
    },
    /** 
     * 根据类型获取课程指定价格
     * @param Object info 课程信息
     * @param Number type 订单类型 1=普通订单 2=拼团订单
     */
    getCoursePriceByType(info = {}, type = 1) {
      if (type == 1) return +info.sale_price || 0;
      return +info.group_price || 0;
    }
  }
})

import { STUDY_MODE, KAOSHI_DATI_MODE, SHIJUAN_STATUS } from './const';

/** 
 * 获取试卷状态
 * @param {object} param = {info 试卷对象 studyModele 学习模块（如考点、母题） answerMode 答题模式（如考试、练习） }
 * @return 1 暂未开放 2 未到开放时间（显示预计开放时间）3 开始（考试、练习、背题）4 继续（考试、练习、背题）
 */
Vue.prototype.getShijuanZhuangtai = function(params = {}) {
  const info = params.info || {},
    studyModele = params.studyModele || STUDY_MODE.YATI,
    answerMode = params.answerMode || KAOSHI_DATI_MODE.KAOSHI;
  /*
    accuracy: 0
    aid: 16
    close_time: 1689696000
    course_kechengmingcheng: "注册会计"
    create_time: 1681811171
    done_num: 0
    is_exam: 0
    name: "2023年会计考试押题(一套)"
    open_time: 1687104000
    schedule: 0
    time: 7200
    total_num: 3
  */
  const cTimeStamp = Date.now() / 1000;
  // 暂未开放（过期或未设置开始时间）
  if (!info.open_time) return SHIJUAN_STATUS.NOT_OPEN;
  if (cTimeStamp >= info.close_time) return SHIJUAN_STATUS.ENDED;
  // 未到开放时间
  if (cTimeStamp < info.open_time) return SHIJUAN_STATUS.NOT_REACH_START_TIME;
  // 开始考试
  if (answerMode == KAOSHI_DATI_MODE.KAOSHI) return info.is_exam == 1 ? SHIJUAN_STATUS.CONTINUE :
    SHIJUAN_STATUS.STARTING;
  // 练习
  if (answerMode == KAOSHI_DATI_MODE.LIANXI) return +info.done_num ? SHIJUAN_STATUS.CONTINUE : SHIJUAN_STATUS
    .STARTING;
  // 背题
  return ~getBeitiSchedule({ type: answerMode, cid: info.aid }) ? SHIJUAN_STATUS.CONTINUE : SHIJUAN_STATUS
    .STARTING;
}

// 全局事件对象
Vue.prototype.eventBus = new Vue();

// 环境变量
Vue.prototype.isdev = process.env.NODE_ENV == "development";

// IM初始化
import { iMInit } from './common/liveModule/im'
Vue.prototype.$Tim = iMInit();

// 加入直播模块
import { liveInitSdk } from '@/common/liveModule/live.js';
liveInitSdk();

// vue 示例
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
